module.exports = __webpack_public_path__ + "media/images/emblems/Regensberg-blazon-324447ee26cd4b89e5141cdf2f5acb62.svg";